var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CanRead } from '@/shared/components/security';
var SettingsSection = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.defaultCollapsed, defaultCollapsed = _b === void 0 ? false : _b, id = _a.id, securityKey = _a.securityKey;
    var _c = useState(defaultCollapsed), collapsed = _c[0], setCollapsed = _c[1];
    var content = (_jsxs("div", __assign({ className: "control-panel subsection", id: id }, { children: [_jsxs("div", __assign({ className: "title-block", onClick: function () { return setCollapsed(function (prev) { return !prev; }); } }, { children: [_jsx("i", { className: "fa fa-inverse ".concat(collapsed ? 'fa-chevron-down' : 'fa-chevron-up') }), _jsx("span", { children: title })] })), !collapsed && (_jsx("div", __assign({ className: "panel-body form-horizontal form-labels-left" }, { children: children })))] })));
    if (securityKey) {
        return _jsx(CanRead, __assign({ on: securityKey }, { children: content }));
    }
    return content;
};
export default SettingsSection;
